module.exports = __webpack_public_path__ + "img/location.3e1d6f6b.svg";